import React, { Component } from "react";

class AutomationPage extends Component {
    render() {
        return(
            <iframe className="node-red" src="http://localhost:1880/" title="Node red"/>
        )
    }
}
export default AutomationPage;
